import React from 'react'
import "./VidLeftTextRight.css"
import ReactPlayer from 'react-player'

export default function VidLeftTextRight() {
  return (
    <div className='vid-left-right__container'>
      <div className='vid-left-right__holder'>
        <ReactPlayer
          width='320px'
          height='200px'
          url='https://www.youtube.com/watch?v=ysz5S6PUM-U' />
        <div className='vid-left-right__text'>
        <h3>If you're ready to stop selling and finally put trust in yourself to find success in your business... This is for you.</h3>
        
          <h3>
            Easily scale your marketing efforts with a sales funnel.
            Just Plug and Play your Analytic accounts to stay on top of conversions.
          </h3>
        </div>
      </div>
    </div>
  )
}
